export default __webpack_public_path__ + "static/media/i28.98dec782.jpg";